"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[3923],{

/***/ 24001:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ SubscriptionLayout_SubscriptionLayout)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(94957);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(96934);
// EXTERNAL MODULE: ./local_modules/date/index.ts
var date = __webpack_require__(76218);
// EXTERNAL MODULE: ./local_modules/date/difference.ts
var difference = __webpack_require__(44541);
// EXTERNAL MODULE: ./src/hooks/useFt.ts
var useFt = __webpack_require__(64667);
// EXTERNAL MODULE: ./src/hooks/useAb.ts
var useAb = __webpack_require__(80550);
// EXTERNAL MODULE: ./local_modules/router/shared/hooks.ts
var hooks = __webpack_require__(91746);
// EXTERNAL MODULE: ./local_modules/modals/manager.ts
var manager = __webpack_require__(39977);
// EXTERNAL MODULE: ./local_modules/cookie-storage/index.ts + 2 modules
var cookie_storage = __webpack_require__(9424);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(63687);
// EXTERNAL MODULE: ./src/modules/brands/useStrapiWSTOBrandSlug.ts
var useStrapiWSTOBrandSlug = __webpack_require__(22606);
// EXTERNAL MODULE: ./src/modules/user/user/index.tsx + 1 modules
var user_user = __webpack_require__(40038);
// EXTERNAL MODULE: ./src/modules/brands/useStrapiWSTOData.ts + 1 modules
var useStrapiWSTOData = __webpack_require__(47479);
;// CONCATENATED MODULE: ./src/modules/brands/useStrapiWSTOModalWithProductsOptions.ts



const ALL_GENDERS = [
    "FEMALE",
    "MALE"
];
const modifyStrapiData = (userGender, data)=>{
    var _data_mainPage;
    const modalData = data === null || data === void 0 ? void 0 : (_data_mainPage = data.mainPage) === null || _data_mainPage === void 0 ? void 0 : _data_mainPage.find((param)=>{
        let { __typename, gender } = param;
        if (__typename !== "ComponentWebsiteTakeoverFeaturedBrandModal") {
            return;
        }
        return gender === userGender || gender === "ALL";
    });
    const availableGenders = !(modalData === null || modalData === void 0 ? void 0 : modalData.gender) || modalData.gender === "ALL" ? ALL_GENDERS : [
        modalData.gender
    ];
    return {
        genders: availableGenders
    };
};
const useStrapiWSTOModalWithProductsOptions = ()=>{
    const { gender } = (0,user_user/* useUser */.aF)();
    const { data, isFetching } = (0,useStrapiWSTOData/* default */.Z)();
    const strapiData = (0,react.useMemo)(()=>{
        return data ? modifyStrapiData(gender, data) : null;
    }, [
        gender,
        data
    ]);
    if (isFetching) {
        return null;
    }
    return strapiData;
};
/* harmony default export */ const brands_useStrapiWSTOModalWithProductsOptions = (useStrapiWSTOModalWithProductsOptions);

// EXTERNAL MODULE: ./src/modules/products/usePrivateSale.ts + 1 modules
var usePrivateSale = __webpack_require__(29703);
// EXTERNAL MODULE: ./src/modules/limitedDrops/useLimitedDropSale.ts + 1 modules
var useLimitedDropSale = __webpack_require__(7178);
// EXTERNAL MODULE: ./src/modules/recommendations/index.ts + 2 modules
var recommendations = __webpack_require__(55731);
// EXTERNAL MODULE: ./src/modules/subscription/subscription/index.tsx + 1 modules
var subscription_subscription = __webpack_require__(36888);
// EXTERNAL MODULE: ./src/modules/subscription/subscriptionAddons/index.ts + 5 modules
var subscriptionAddons = __webpack_require__(88852);
// EXTERNAL MODULE: ./src/modules/user/shownPopups/index.tsx + 2 modules
var user_shownPopups = __webpack_require__(59247);
// EXTERNAL MODULE: ./src/modules/user/referralProgram/index.ts
var referralProgram = __webpack_require__(21380);
// EXTERNAL MODULE: ./src/modules/academy/index.ts + 2 modules
var academy = __webpack_require__(53526);
;// CONCATENATED MODULE: ./src/containers/SubscriptionLayout/components/SubscriptionModals/SubscriptionModals.tsx
















// ATTN all loading should be processed inside modals, because we should show only one modal at once
const SubscriptionModals = ()=>{
    // data for modals
    const pathname = (0,hooks/* usePathname */.jD)();
    const { isMobile } = (0,useDevice/* default */.Z)();
    const [{ autoTestSkip }] = (0,hooks/* useSearchParams */.lr)();
    const modalWasOpenRef = (0,react.useRef)(Boolean(autoTestSkip));
    const isCandleSubscriptionEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.candleSubscription);
    const isDriftSubscriptionEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.driftSubscription);
    const isSaksCollaborationEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.collaborationSaks);
    const isMobileAppEntrypointModalEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.mobileAppEntryPoint);
    const isLimitedDropsEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.limitedDrops);
    const isDriftEcommercePromoEnabled = (0,useFt/* default */.Z)(constants/* default */.Z.features.driftEcommercePromo);
    const isQueueUpgradePopupEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.upgradePopup) === "b";
    const strapiWSTOBrandSlug = (0,useStrapiWSTOBrandSlug/* default */.Z)();
    const strapiWSTOModalWithProductsOptions = brands_useStrapiWSTOModalWithProductsOptions();
    const isStrapiWSTOEnabled = Boolean(strapiWSTOBrandSlug);
    const { user, isLoggedIn } = (0,user_user/* useUser */.aF)();
    const { subscription } = (0,subscription_subscription/* useSubscription */.mU)();
    const { candleSubscription } = (0,subscriptionAddons/* useCandleSubscription */.pj)();
    const { caseSubscription } = (0,subscriptionAddons/* useCaseSubscription */.PZ)();
    const { driftSubscription } = (0,subscriptionAddons/* useDriftSubscription */.RD)();
    const { shownPopups } = (0,user_shownPopups/* useShownPopups */.BP)();
    const setPopupShown = (0,user_shownPopups/* useSetPopupShown */.aw)();
    const { privateSale, isFetching } = (0,usePrivateSale/* default */.Z)();
    const { product: unratedProduct, recommenderName: unratedProductRecommenderName, isFetching: isUnratedProductFetching } = (0,recommendations/* useUnratedProduct */.R)({
        skip: !isLoggedIn
    });
    const { data: limitedDrop, isFetching: isLimitedDropFetching } = (0,useLimitedDropSale/* default */.Z)();
    const { stats: { available: availableReferralInvites } } = (0,referralProgram/* useReferralInvites */.n)();
    const { data: scentbirdAcademyCourse, isFetching: isScentbirdAcademyCourseFetching } = (0,academy/* useAcademyCoursePromo */.mF)();
    const isScentbirdAcademyPopupEnabled = (subscription === null || subscription === void 0 ? void 0 : subscription.isActive) && (scentbirdAcademyCourse === null || scentbirdAcademyCourse === void 0 ? void 0 : scentbirdAcademyCourse.status) === "AVAILABLE";
    (0,react.useEffect)(()=>{
        var _shownPopups_candleSubscriptionPromoModal;
        if (modalWasOpenRef.current) {
            return;
        }
        // loading state
        if (!isLoggedIn || !user || !subscription || !shownPopups || isFetching || isUnratedProductFetching || isLimitedDropFetching || isScentbirdAcademyCourseFetching) {
            return;
        }
        // some modals should be opened only on main page
        const isMainPage = pathname === links/* default */.ZP.subscription.main;
        /**
     * ATTN if you already have a modal in Modals file, just import it`s module and open.
     *  Otherwise, import a module and use setActiveModal to load and open it.
     */ const lastShipmentReviewModal = (priority)=>{
            /**
       If a customer closes the popup we will show it again 2 weeks after.
       If a customer closes the second popup we don’t show it again.
       New “Delivery” event will trigger a new popup.
       */ if (!unratedProduct) {
                return;
            }
            const popupId = `lastShipmentReview_${unratedProduct.id}`;
            const { count = 0, lastUpdated = 0 } = shownPopups[popupId] || {};
            const lastUpdateTime = new Date(lastUpdated).getTime() + 14 * 24 * 60 * 60 * 1000 // 14 days between shows
            ;
            const isVisible = isMainPage && (count === 0 || count === 1 && Date.now() > lastUpdateTime);
            if (isVisible) {
                const onReviewModalClose = ()=>setPopupShown(popupId);
                if (isMobile) {
                    (0,manager/* openModal */.h7)("lastShipmentReviewModal", {
                        priority,
                        product: unratedProduct,
                        recommenderName: unratedProductRecommenderName,
                        onClose: onReviewModalClose
                    });
                } else {
                    (0,manager/* openModal */.h7)("productReviewModal", {
                        flow: "Review popup",
                        placement: "Page body",
                        productId: unratedProduct.id,
                        recommenderName: unratedProductRecommenderName,
                        onClose: onReviewModalClose
                    });
                }
                return true;
            }
        };
        const inviteModal = (priority)=>{
            const isPathnameAcceptable = pathname === links/* default */.ZP.subscription.perfumes || pathname === links/* default */.ZP.subscription.colognes || pathname === links/* default */.ZP.subscription.main;
            const isReferralItemVisible = isPathnameAcceptable && availableReferralInvites > 0;
            if (isReferralItemVisible) {
                const { lastUpdated } = shownPopups.inviteModal || {};
                const lastUpdatedDate = (0,date/* default */.ZP)(lastUpdated || 0);
                const now = (0,date/* default */.ZP)();
                // open each month after 2nd, because we add credits after the 2nd every month
                if (!lastUpdated || now.isAfter(lastUpdatedDate, "month") && now.date() >= 2) {
                    (0,manager/* openModal */.h7)("inviteModal", {
                        priority,
                        onClose: ()=>setPopupShown("inviteModal")
                    });
                    return true;
                }
            }
        };
        const cardUpdateModal = (priority)=>{
            const isShownInSession = cookie_storage/* default */.ZP.getItem(constants/* default */.Z.cookieNames.isCardUpdateModalShown);
            const isVisible = isMainPage && subscription.isUnpaid && !isShownInSession;
            if (isVisible) {
                (0,manager/* openModal */.h7)("cardUpdateModal", {
                    priority,
                    flow: "Website visit"
                });
                return true;
            }
        };
        const firstTimeVisitModal = (priority)=>{
            var _shownPopups_firstTimeVisitModal;
            // This modal should be only visible on mobile as a result of CRO-97 ab test
            const isVisible = isMobile && isMainPage && subscription.hasNeverSubscribed && !(shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_firstTimeVisitModal = shownPopups.firstTimeVisitModal) === null || _shownPopups_firstTimeVisitModal === void 0 ? void 0 : _shownPopups_firstTimeVisitModal.count);
            if (isVisible) {
                (0,manager/* openModal */.h7)("firstTimeVisitModal", {
                    priority
                });
                return true;
            }
        };
        const candleSubscriptionPromoModalShownCount = (shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_candleSubscriptionPromoModal = shownPopups.candleSubscriptionPromoModal) === null || _shownPopups_candleSubscriptionPromoModal === void 0 ? void 0 : _shownPopups_candleSubscriptionPromoModal.count) || 0;
        const candleSubscriptionPromoModal = (priority)=>{
            var _shownPopups_candleSubscriptionPromoModal;
            const lastUpdated = shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_candleSubscriptionPromoModal = shownPopups.candleSubscriptionPromoModal) === null || _shownPopups_candleSubscriptionPromoModal === void 0 ? void 0 : _shownPopups_candleSubscriptionPromoModal.lastUpdated;
            const isVisible = isMainPage && isCandleSubscriptionEnabled && (candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.isEnabled) && !(candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.isSelected) && candleSubscriptionPromoModalShownCount < 3 && (!lastUpdated || (0,difference/* getElapsedTime */.q)(lastUpdated, "hours") >= 24);
            if (isVisible) {
                (0,manager/* openModal */.h7)("candleSubscriptionPromoModal", {
                    priority
                });
                return true;
            }
        };
        const privateSaleModal = (priority)=>{
            if (!privateSale) {
                return;
            }
            const popupName = `privateSale${new Date(privateSale.startDate).getTime()}`;
            const wasNotShownBefore = !(shownPopups === null || shownPopups === void 0 ? void 0 : shownPopups[popupName]);
            const isVisible = isLoggedIn && privateSale.timeLeft > 5000 && wasNotShownBefore;
            if (isVisible) {
                (0,manager/* openModal */.h7)("privateSaleModal", {
                    priority,
                    popupName
                });
                return true;
            }
        };
        const tossInModal = (priority)=>{
            var _shownPopups_tossInModal;
            const month = new Date().getMonth();
            const year = new Date().getFullYear();
            const lastUpdated = shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_tossInModal = shownPopups.tossInModal) === null || _shownPopups_tossInModal === void 0 ? void 0 : _shownPopups_tossInModal.lastUpdated;
            let isVisible = subscription === null || subscription === void 0 ? void 0 : subscription.canApplyTossInOffer;
            if (lastUpdated) {
                const popupMonth = new Date(lastUpdated).getMonth();
                const popupYear = new Date(lastUpdated).getFullYear();
                // hide the popup if it was closed in the current month
                if (month === popupMonth && year === popupYear) {
                    isVisible = false;
                }
            }
            if (isVisible) {
                (0,manager/* openModal */.h7)("tossInModal", {
                    priority
                });
                return true;
            }
        };
        const verifyShippingAddressModal = (priority)=>{
            const { isShippingAddressInvalid, isShippingAddressUndeliverable } = subscription;
            if (isMainPage && isShippingAddressInvalid) {
                (0,manager/* openModal */.h7)("verifyShippingAddressModal", {
                    isUndeliverable: isShippingAddressUndeliverable,
                    priority
                });
                return true;
            }
        };
        const tryTwoThreeFragrancesModal = (priority)=>{
            var _shownPopups_tryTwoThreeFragrancesModal, _subscription_credits;
            const lastUpdated = shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_tryTwoThreeFragrancesModal = shownPopups.tryTwoThreeFragrancesModal) === null || _shownPopups_tryTwoThreeFragrancesModal === void 0 ? void 0 : _shownPopups_tryTwoThreeFragrancesModal.lastUpdated;
            const isVisible = (subscription === null || subscription === void 0 ? void 0 : subscription.isUpgradableFromMonthlyPlan) && (subscription === null || subscription === void 0 ? void 0 : (_subscription_credits = subscription.credits) === null || _subscription_credits === void 0 ? void 0 : _subscription_credits.free) === 0 && (0,difference/* getElapsedTime */.q)(subscription.subscriptionDate, "days") >= 1 // 1 day after subscription
             && (!lastUpdated || (0,difference/* getElapsedTime */.q)(lastUpdated, "days") >= 30);
            if (isVisible) {
                const onClose = ()=>{
                    // ATTN both popups use the same popupShown ids
                    void setPopupShown("tryTwoThreeFragrancesModal");
                };
                if (isQueueUpgradePopupEnabled) {
                    (0,manager/* openModal */.h7)("addToQueueUpgradeModal", {
                        priority,
                        onClose
                    });
                } else {
                    (0,manager/* openModal */.h7)("tryTwoThreeFragrancesModal", {
                        priority,
                        onClose
                    });
                }
                return true;
            }
        };
        const resubscribePromoModal = (priority)=>{
            const isVisible = (isMainPage || pathname === links/* default */.ZP.subscription.perfumes || pathname === links/* default */.ZP.subscription.colognes) && subscription.isCancelled && !cookie_storage/* default */.ZP.getItem(constants/* default */.Z.cookieNames.isResubscribePromoModalShown);
            if (isVisible) {
                (0,manager/* openModal */.h7)("resubscribePromoModal", {
                    priority
                });
                return true;
            }
        };
        const mobileAppModal = (priority)=>{
            var _shownPopups_mobileAppModal;
            const isVisible = !(shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_mobileAppModal = shownPopups.mobileAppModal) === null || _shownPopups_mobileAppModal === void 0 ? void 0 : _shownPopups_mobileAppModal.lastUpdated) && isMobile;
            if (isVisible) {
                (0,manager/* openModal */.h7)("mobileAppModal", {
                    priority
                });
                return true;
            }
        };
        const featuredBrandModal = (priority)=>{
            var _shownPopups_;
            const gender = user === null || user === void 0 ? void 0 : user.gender;
            const isVisibleForGender = strapiWSTOModalWithProductsOptions && gender ? strapiWSTOModalWithProductsOptions.genders.includes(gender) : true;
            const isVisible = isStrapiWSTOEnabled && isVisibleForGender && !(shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_ = shownPopups[`featuredBrandModal-${strapiWSTOBrandSlug}`]) === null || _shownPopups_ === void 0 ? void 0 : _shownPopups_.lastUpdated);
            if (isVisible) {
                (0,manager/* openModal */.h7)("featuredBrandModal", {
                    priority
                });
                return true;
            }
        };
        const driftEcommercePromoModal = (priority)=>{
            var _shownPopups_driftPromoModal;
            const isVisible = isDriftEcommercePromoEnabled && !isDriftSubscriptionEnabled && !(shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_driftPromoModal = shownPopups["driftPromoModal"]) === null || _shownPopups_driftPromoModal === void 0 ? void 0 : _shownPopups_driftPromoModal.lastUpdated);
            if (isVisible) {
                (0,manager/* openModal */.h7)("driftPromoModal", {
                    priority
                });
                return true;
            }
        };
        const collaborationModal = (priority)=>{
            var _shownPopups_scentbirdSelectModal;
            if (!isSaksCollaborationEnabled) {
                return;
            }
            if (!(shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_scentbirdSelectModal = shownPopups.scentbirdSelectModal) === null || _shownPopups_scentbirdSelectModal === void 0 ? void 0 : _shownPopups_scentbirdSelectModal.lastUpdated)) {
                (0,manager/* openModal */.h7)("scentbirdSelectModal", {
                    priority
                });
                return true;
            }
        };
        const limitedDropModal = (priority)=>{
            var _shownPopups_;
            const isVisible = isLimitedDropsEnabled && (limitedDrop === null || limitedDrop === void 0 ? void 0 : limitedDrop.status) === "LIVE" && !(limitedDrop === null || limitedDrop === void 0 ? void 0 : limitedDrop.hasReachedBurndown) && !(shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_ = shownPopups[`limitedDropModal-${limitedDrop === null || limitedDrop === void 0 ? void 0 : limitedDrop.uid}`]) === null || _shownPopups_ === void 0 ? void 0 : _shownPopups_.lastUpdated);
            if (isVisible) {
                (0,manager/* openModal */.h7)("limitedDropModal", {
                    priority
                });
                return true;
            }
        };
        const caseSubscriptionPromoModal = (priority)=>{
            var _shownPopups_caseSubscriptionPromoModal;
            const lastUpdated = shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_caseSubscriptionPromoModal = shownPopups.caseSubscriptionPromoModal) === null || _shownPopups_caseSubscriptionPromoModal === void 0 ? void 0 : _shownPopups_caseSubscriptionPromoModal.lastUpdated;
            const isVisible = isMainPage && (caseSubscription === null || caseSubscription === void 0 ? void 0 : caseSubscription.isEnabled) && !(caseSubscription === null || caseSubscription === void 0 ? void 0 : caseSubscription.isSelected) && (!lastUpdated || (0,difference/* getElapsedTime */.q)(lastUpdated, "months") >= 1);
            if (isVisible) {
                (0,manager/* openModal */.h7)("caseSubscriptionPromoModal", {
                    priority
                });
                return true;
            }
        };
        const driftSubscriptionPromoModal = (priority)=>{
            var _shownPopups_driftSubscriptionPromoModal;
            const lastUpdated = shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_driftSubscriptionPromoModal = shownPopups.driftSubscriptionPromoModal) === null || _shownPopups_driftSubscriptionPromoModal === void 0 ? void 0 : _shownPopups_driftSubscriptionPromoModal.lastUpdated;
            const isVisible = isMainPage && isDriftSubscriptionEnabled && (driftSubscription === null || driftSubscription === void 0 ? void 0 : driftSubscription.isEnabled) && !(driftSubscription === null || driftSubscription === void 0 ? void 0 : driftSubscription.isSelected) && (!lastUpdated || (0,difference/* getElapsedTime */.q)(lastUpdated, "months") >= 1);
            if (isVisible) {
                (0,manager/* openModal */.h7)("driftSubscriptionPromoModal", {
                    priority
                });
                return true;
            }
        };
        const continueMobileAppModal = (priority)=>{
            const haveShown = Boolean(shownPopups === null || shownPopups === void 0 ? void 0 : shownPopups.continueMobileAppModal);
            const isVisible = isMobileAppEntrypointModalEnabled && (subscription === null || subscription === void 0 ? void 0 : subscription.isActive) && !haveShown && isMobile && (isMainPage || pathname === links/* default */.ZP.subscription.perfumes || pathname === links/* default */.ZP.subscription.colognes);
            if (isVisible) {
                (0,manager/* openModal */.h7)("continueMobileAppModal", {
                    priority
                });
                return true;
            }
        };
        const scentbirdAcademyModal = (priority)=>{
            var _shownPopups_scentbirdAcademyModal;
            const wasShown = (shownPopups === null || shownPopups === void 0 ? void 0 : (_shownPopups_scentbirdAcademyModal = shownPopups.scentbirdAcademyModal) === null || _shownPopups_scentbirdAcademyModal === void 0 ? void 0 : _shownPopups_scentbirdAcademyModal.count) > 0;
            const isVisible = isMainPage && isScentbirdAcademyPopupEnabled && !wasShown // once
            ;
            if (isVisible) {
                const popupId = "scentbirdAcademyModal";
                (0,manager/* openModal */.h7)(popupId, {
                    priority,
                    onClose: ()=>void setPopupShown(popupId)
                });
                return true;
            }
        };
        const modalsOrder = [
            resubscribePromoModal,
            verifyShippingAddressModal,
            firstTimeVisitModal,
            cardUpdateModal,
            scentbirdAcademyModal,
            driftSubscriptionPromoModal,
            driftEcommercePromoModal,
            caseSubscriptionPromoModal,
            lastShipmentReviewModal,
            candleSubscriptionPromoModalShownCount === 0 && candleSubscriptionPromoModal,
            tryTwoThreeFragrancesModal,
            privateSaleModal,
            tossInModal,
            mobileAppModal,
            candleSubscriptionPromoModalShownCount > 0 && candleSubscriptionPromoModal,
            limitedDropModal,
            collaborationModal,
            featuredBrandModal,
            inviteModal,
            continueMobileAppModal
        ].filter(Boolean);
        modalsOrder.some((checker, index)=>checker(index + 1));
        modalWasOpenRef.current = true;
    }, [
        shownPopups,
        setPopupShown,
        subscription,
        user,
        isLoggedIn,
        pathname,
        privateSale,
        unratedProduct,
        unratedProductRecommenderName,
        limitedDrop,
        isMobile,
        isFetching,
        isDriftEcommercePromoEnabled,
        isUnratedProductFetching,
        isCandleSubscriptionEnabled,
        isDriftSubscriptionEnabled,
        isStrapiWSTOEnabled,
        isSaksCollaborationEnabled,
        isLimitedDropFetching,
        isLimitedDropsEnabled,
        candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.isEnabled,
        candleSubscription === null || candleSubscription === void 0 ? void 0 : candleSubscription.isSelected,
        caseSubscription === null || caseSubscription === void 0 ? void 0 : caseSubscription.isEnabled,
        caseSubscription === null || caseSubscription === void 0 ? void 0 : caseSubscription.isSelected,
        driftSubscription === null || driftSubscription === void 0 ? void 0 : driftSubscription.isEnabled,
        driftSubscription === null || driftSubscription === void 0 ? void 0 : driftSubscription.isSelected,
        strapiWSTOBrandSlug,
        strapiWSTOModalWithProductsOptions,
        isMobileAppEntrypointModalEnabled,
        isQueueUpgradePopupEnabled,
        isScentbirdAcademyCourseFetching,
        isScentbirdAcademyPopupEnabled,
        availableReferralInvites
    ]);
    return null;
};
/* harmony default export */ const SubscriptionModals_SubscriptionModals = (SubscriptionModals);

;// CONCATENATED MODULE: ./src/containers/SubscriptionLayout/SubscriptionLayout.tsx



const SubscriptionLayout = (param)=>{
    let { children } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriptionModals_SubscriptionModals, {})
        ]
    });
};
/* harmony default export */ const SubscriptionLayout_SubscriptionLayout = (SubscriptionLayout);


/***/ })

}]);